import React from "react";

function GloablButton({
  type = "button",
  className = "",
  width = "200px",
  maxWidth = "100%",
  height = "48px",
  backgroundColor = "#F97316",
  background,
  text = "Button",
  icon = null,
  iconPosition = "left",
  gap = "10px",
  borderRadius = "8px",
  color = "#FFFFFF",
  padding = "10px",
  boxShadow = "none",
  border = "none",
  fontSize = "14px",
  fontStyle = "normal",
  fontWeight = 700,
  lineHeight = "20px",
  flexDirection = "row",
  buttonFlex,
  buttonOrder,
  buttonFlexGrow,
  textWidth,
  textHeight,
  textFlex,
  textOrder,
  textFlexGrow,
  textOverflow = "hidden",
  textOverflowMode = "ellipsis",
  textWhiteSpace = "nowrap",
  onClick,
  disabled = false,
}) {
  return (
    <button
      type={type}
      className={className}
      onClick={onClick}
      disabled={disabled}
      style={{
        width,
        maxWidth,
        height,
        background: background || backgroundColor,
        border,
        borderRadius,
        display: "flex",
        flexDirection,
        alignItems: "center",
        justifyContent: "center",
        gap,
        flex: buttonFlex,
        order: buttonOrder,
        flexGrow: buttonFlexGrow,
        cursor: disabled ? "not-allowed" : "pointer",
        padding,
        boxSizing: "border-box",
        boxShadow,
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {icon && iconPosition === "left" ? (
        <span style={{ display: "flex", alignItems: "center" }}>{icon}</span>
      ) : null}
      <span
        style={{
          width: textWidth,
          height: textHeight,
          flex: textFlex,
          order: textOrder,
          flexGrow: textFlexGrow,
          fontFamily: "Inter",
          fontStyle,
          fontWeight,
          fontSize,
          lineHeight,
          color,
          textAlign: "center",
          whiteSpace: textWhiteSpace,
          overflow: textOverflow,
          textOverflow: textOverflowMode,
        }}
      >
        {text}
      </span>
      {icon && iconPosition === "right" ? (
        <span style={{ display: "flex", alignItems: "center" }}>{icon}</span>
      ) : null}
    </button>
  );
}

export default GloablButton;
